export type FillMark = "filled" | "missing";

export class ExtractFillMap {
  private readonly filled: ReadonlySet<string>;
  private readonly missing: ReadonlySet<string>;

  constructor(filledIds: readonly string[] = [], missingIds: readonly string[] = []) {
    this.filled = new Set(filledIds);
    this.missing = new Set(missingIds);
  }

  hasFilled(): boolean {
    return this.filled.size > 0;
  }

  status(id: string): FillMark | undefined {
    if (this.filled.has(id)) return "filled";
    if (this.missing.has(id)) return "missing";
    return undefined;
  }
}
